import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'
import {MesActionsForm} from '../../mesActions/components/MesActionsForm'
import {
  ModeleMesActions,
  modeleMesActionsInitValues,
} from '../../../../components/Models'
import {
  createMesActions,
  editAction,
} from '../../../../components/requests'

const ModalActions = (props) => {
  const {
    dataProps,
    clearInput,
    readOnly,
    onAddComment,
    onUpdateComment,
    isRealisation,
    onRealisation,
    statutButton,
    onStatutButton,
  } = props

  const modalRef = useRef<HTMLDivElement | null>(null)
  const closeRef = useRef<HTMLButtonElement | null>(null)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleMesActions>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign(
      {...modeleMesActionsInitValues},
      fieldsToUpdate
    )

    try {
      const actionRequest = isRealisation
        ? await editAction(dataProps?.id, updatedData)
        : await createMesActions(updatedData)

      if (actionRequest?.status === 200) {
        if (
          actionRequest?.data?.id !== undefined &&
          actionRequest?.data?.id !== null
        ) {
          if (isRealisation) {
            onUpdateComment(actionRequest.data)
          } else {
            onAddComment(actionRequest.data)
          }
          clearInput()
          if (closeRef.current) {
            closeRef.current.click()
          }
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  useEffect(() => {
    const modal = modalRef.current

    if (!modal) {
      return
    }

    const handleShown = () => {
      setIsModalOpen(true)
    }

    const handleHidden = () => {
      setIsModalOpen(false)

      onRealisation(false)
      onStatutButton(null)

      if (props?.onReadOnly) {
        props.onReadOnly(false)
      }
    }

    modal.addEventListener(
      'shown.bs.modal',
      handleShown
    )

    modal.addEventListener(
      'hidden.bs.modal',
      handleHidden
    )

    return () => {
      modal.removeEventListener(
        'shown.bs.modal',
        handleShown
      )

      modal.removeEventListener(
        'hidden.bs.modal',
        handleHidden
      )
    }
  }, [
    onRealisation,
    onStatutButton,
    props,
  ])

  const handleCancel = () => {
    if (closeRef.current) {
      closeRef.current.click()
    }
  }

  const hideModal = () => {
    if (closeRef.current) {
      closeRef.current.click()
    }
  }

  return (
    <div
      className='modal fade'
      id='modalActions'
      aria-hidden='true'
      aria-labelledby='exampleModalToggleActions'
      tabIndex={-1}
      ref={modalRef}
    >
      <div className='modal-dialog modal-dialog-scrollable modal-lg'>
        <div className='modal-content'>

          <div className='modal-header'>
            <h5
              className='modal-title'
              id='exampleModalToggleActions'
            >
              Mes actions
            </h5>

            <button
              type='button'
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              ref={closeRef}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </button>
          </div>

          <div className='modal-body'>
            {isModalOpen && (
              <MesActionsForm
                data={dataProps}
                submitForm={submitForm}
                viaDemande={true}
                cancelAction={handleCancel}
                readOnly={readOnly}
                isRealisation={isRealisation}
                clearValue={clearInput}
                hideModal={hideModal}
                statutButton={statutButton}
                onUpdateComment={onUpdateComment}
                modalRef={modalRef}
              />
            )}
          </div>
        </div>
      </div>
      <Tooltip id='modal-tooltip' />
    </div>
  )
}

export default ModalActions